// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoStarOutlinedSvg from "@fishx/icons-svg/es/asn/PtoStarOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoStarOutlined = function PtoStarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoStarOutlinedSvg
  }));
};

PtoStarOutlined.displayName = 'PtoStarOutlined';
export default React.forwardRef(PtoStarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoStarOutlined.js
// module id = 3932
// module chunks = 0